import React from 'react';
import UrlParse from 'url-parse';
import Loading from '../../components/loading';
import GeneralHelper from '../../helpers/general';
import XLSX from 'xlsx';
import Papa from 'papaparse';
import { Button, Table, Row, DatePicker, Input } from 'antd';
import { SearchOutlined,  DownloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import ListLayout from '../../layouts/list-layout';

const { RangePicker } = DatePicker;

const ENTRY_PER_PAGE = 10000;

class ReportListPage extends React.Component {
	state = {
		equipment: '',
		date_range: []
	};

	initialState = {...this.state};

	componentDidMount() {
		this.getEquipments();
	}

	componentDidUpdate(prevProps) {
		const { crf_id: prevCrfId } = prevProps.drawerReducer;
		const { crf_id: newCrfId } = this.props.drawerReducer;
		// check hall_id / bldg_cde if change to change what the user will see
		if(prevCrfId !== newCrfId) {
			this.setState(this.initialState);
			this.props.resetPage();
			this.getEquipments();
		}

		const {
			meta: prevMeta,
			hasDownloadSuccess: prev_hasDownloadSuccess
		} = prevProps.downloadProps;
		const {
			meta,
			hasDownloadSuccess
		} = this.props.downloadProps;

		if (meta && meta !== prevMeta) {
			this.props.resetMeta();
		}

		// Download
		if (hasDownloadSuccess && hasDownloadSuccess !== prev_hasDownloadSuccess) {
			const { csv_string: downloadCsv } = this.props.downloadProps;
			if (downloadCsv) {
				this.downloadXlsx({
					csv: downloadCsv,
					fileName: `Usage_Report - ${moment().format('YYYY-MM-DD HH-mm-ss')}.xlsx`
				});
			}
		}
	}

	downloadXlsx = ({ csv, fileName }) => {
		const usageSummaryCsvRows = (Papa.parse(csv)).data;
		const wb = XLSX.utils.book_new();
		const usageWs = XLSX.utils.aoa_to_sheet(usageSummaryCsvRows);
		XLSX.utils.book_append_sheet(wb, usageWs, 'Usage');

		if (navigator && navigator.msSaveOrOpenBlob) {
			const data = XLSX.write(wb, {
				type: 'array',
				bookType: 'xlsx'
			});
			const blob = new Blob([data]);
			navigator.msSaveOrOpenBlob(blob, fileName);
			return;
		}

		// write to b64
		const fileBase64 = XLSX.write(wb, {
			type: 'base64',
			bookType: 'xlsx'
		});

		const encodedUri = encodeURI(`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${fileBase64}`);
		let a = document.createElement('a');
		document.body.appendChild(a);
		a.href = encodedUri;
		a.download = fileName;
		a.click();
	}

	downloadCsv = ({ csv, fileName }) => {
		if (navigator && navigator.msSaveBlob) {
			const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
			navigator.msSaveBlob(blob, fileName);
			return;
		}
		const encodedUri = encodeURI(`data:text/csv;charset=utf-8,${csv}`);
		let a = document.createElement('a');
		document.body.appendChild(a);
		a.href = encodedUri;
		a.download = fileName;
		a.click();
	}

	confirmDownload = () => {
		const { search } = this.props.pageProps;
		const { date_range, equipment } = this.state;
		if (window.confirm('Are you sure you want to download?')) {
			if(search && date_range || search && equipment) {
				const searchReports = {
					...(date_range && { date_start: date_range[0], date_end: date_range[1] }),
					...(equipment && { equipment })
				};
				this.props.downloadReports(searchReports);
			} else {
				this.props.downloadReports();
			}
		}
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	onPageChange = (page, limit) => {
		return this.getEquipments({ page, limit });
	}

	onFieldChange = (data) => {
		if(data.name === 'equipment') {
			this.setState({ ...this.state, [data.name]: GeneralHelper.toNormalCase(data.value) });
			return;
		}
		this.setState({ ...this.state, [data.name]: data.value });
	};

	getEquipments = async opts => {
		const { query } = UrlParse(this.props.location.search, true);
		const {
			page,
			limit
		} = opts || {};

		this.props.getEquipments({
			page: page || query.page || 1,
			limit: limit || query.limit || ENTRY_PER_PAGE,
			report: true
		});
	}

	getFilteredEquipments = async opts => {
		const { query } = UrlParse(this.props.location.search, true);
		const { equipment, date_range } = this.state;
		const {
			page,
			limit
		} = opts || {};

		this.props.getFilteredEquipments({
			page: page || query.page || 1,
			limit: limit || query.limit || ENTRY_PER_PAGE,
			search: {
				...(equipment && {name: equipment}),
				...(date_range && { date_range })
			},
			report: true
		});
	}

	render() {
		const { loading, equipments, filteredEquipments, search } = this.props.pageProps;
		const { equipment, date_range } = this.state;

		const columns = [
			{
				title: 'Equipments',
				dataIndex: 'name',
				key: 'name',
				render: (name) => GeneralHelper.truncateString(name, 75)
			}
		];

		return(
			<>
				<ListLayout
					title="Equipment Usage Report"
				>
					{ loading ?
						<Loading /> :
						<>
							<Row
								className={'search-input-container'}
								style={{ paddingBottom: 10, paddingTop: 10, paddingRight: 12 }}
							>
								<RangePicker
									optionFilterProp="children"
									value={date_range}
									onChange={(value) => {
										const data = {
											name: 'date_range',
											value
										};
										this.onFieldChange(data);
									}}
									onSearch={(value) => {
										const data = {
											name: 'date_range',
											value
										};
										this.onFieldChange(data);
									}}
									style={{ maxWidth: 250, marginRight: 10 , marginTop: 5}}
									allowClear
								/>
								<Input
									placeholder="Search Equipment"
									value={equipment}
									onChange={(e) => {
										const data = {
											name: 'equipment',
											value: e.target.value
										};
										this.onFieldChange(data);
									}}
									style={{ maxWidth: 230, marginRight: 10, marginTop: 5 }}
									allowClear
								/>
								<Button
									icon={<SearchOutlined />}
									style={{ background: '#003366', color: '#ffffff', marginRight: 10, marginTop: 5 }}
									onClick={this.getFilteredEquipments}
								>
										Search
								</Button>
								<Button
									icon={<DownloadOutlined />}
									style={{ background: '#003366', color: '#ffffff', marginRight: 10, marginTop: 5 }}
									onClick={this.confirmDownload}
								>
										Download All
								</Button>
							</Row>
							<Table
								rowKey={equipment => equipment._id}
								columns={columns}
								dataSource={search ? filteredEquipments : equipments }
								style={{ width: '100%', marginTop: 5, paddingRight: 20, paddingLeft: 20 }}
								scroll={{ x: 400 }}
							/>
						</>
					}
				</ListLayout>
				<div className="copyright">
					<p>Copyright &copy; The Hong Kong University of Science and Technology. <em>All rights reserved.</em></p>
				</div>
			</>
		);
	}
}

export default ReportListPage;
